<template>
  <v-card class="mb-2">
    <div class="caption text--secondary">[{{ data.sort + 1 }}] {{ title }}</div>
    <v-card-text>
      <slot />
    </v-card-text>
    <v-card-actions size="sm">
      <v-spacer></v-spacer>
      <v-btn
        v-if="data.sort > 0"
        color="blue lighten-3"
        fab
        x-small
        elevation="1"
        @click="move('up')"
      >
        <v-icon color="white">mdi-chevron-up</v-icon>
      </v-btn>
      <v-btn
        v-if="!isLast"
        color="blue lighten-3"
        fab
        x-small
        elevation="1"
        @click="move('down')"
      >
        <v-icon color="white">mdi-chevron-down</v-icon>
      </v-btn>
      &nbsp;

      <v-btn color="primary" fab x-small elevation="1" @click="edit">
        <v-icon dark>mdi-pencil</v-icon>
      </v-btn>
      &nbsp;
      <v-dialog v-model="delDiag" width="500">
        <template #activator="{ on, attrs }">
          <v-btn
            color="error"
            fab
            x-small
            elevation="1"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon dark>mdi-delete</v-icon>
          </v-btn>
        </template>

        <v-card>
          <v-card-title class="headline"> Удалить блок? </v-card-title>

          <v-card-text> Удалить блок? Операция необратима! </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="blue" text @click="delDiag = false"> Отмена </v-btn>

            <v-btn color="red darken-1" text @click="remove">Удалить</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      &nbsp;
      <v-menu offset-y>
        <template #activator="{ on, attrs }">
          <v-btn
            color="success"
            fab
            x-small
            elevation="1"
            v-bind="attrs"
            title="Добавить блок под этим"
            v-on="on"
          >
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(text, type) in possibleNext"
            :key="type"
            @click="createNext(type)"
          >
            <v-list-item-title>{{ text }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "BlockTemplate",
  props: {
    data: {
      type: Object,
      required: true,
      sort: Number,
      article_id: Number,
      lang: String
    },
    title: {
      type: String,
      required: true
    },
    possibleNext: {
      type: Object,
      required: true
    },
    isLast: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      delDiag: false
    };
  },
  methods: {
    edit() {
      this.$parent.$emit("edit", this.data);
    },
    remove() {
      this.delDiag = false;
      this.$parent.$emit("remove", this.data);
    },
    move(dir) {
      console.log(this.$parent);
      this.$parent.$emit("move", this.data, dir);
    },
    createNext(type) {
      this.$parent.$emit("create", {
        type,
        article_id: this.data.article_id,
        lang: this.data.lang,
        after: this.data.id
      });
    }
  }
}
</script>
